import React from 'react'
import PropTypes from 'prop-types'

const MutedIcon = ({ width, height, title }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 41 40"
    // fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Mute/Unmure">
      <rect id="Rectangle 1520" x="1.17188" y="0.75" width="38.5" height="38.5" rx="19.25" fill="#151515" fillOpacity="0.8" stroke="currentColor" strokeWidth="1.5" />
      <g id="Mute Icon">
        <path id="Vector" d="M24.3082 12L18.5939 16.5714H14.0225V23.4286H18.5939L24.3082 28V12Z" fill="currentColor" />
        <path id="Vector (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M24.5988 11.3942C24.8317 11.5062 24.9799 11.7417 24.9799 12.0002V28.0002C24.9799 28.2586 24.8317 28.4941 24.5988 28.6061C24.3659 28.718 24.0894 28.6865 23.8876 28.5251L18.3575 24.101H14.0219C13.6506 24.101 13.3496 23.8 13.3496 23.4287V16.5716C13.3496 16.2003 13.6506 15.8993 14.0219 15.8993H18.3575L23.8876 11.4752C24.0894 11.3138 24.3659 11.2823 24.5988 11.3942ZM23.6353 13.3989L19.0133 17.0965C18.8941 17.1919 18.746 17.2439 18.5933 17.2439H14.6941V22.7565H18.5933C18.746 22.7565 18.8941 22.8084 19.0133 22.9038L23.6353 26.6014V13.3989Z" fill="currentColor" />
        <path id="Vector 2 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M10.0063 9.58416C10.236 9.35444 10.6084 9.35444 10.8382 9.58416L30.4382 29.1842C30.6679 29.4139 30.6679 29.7863 30.4382 30.016C30.2084 30.2458 29.836 30.2458 29.6063 30.016L10.0063 10.416C9.77655 10.1863 9.77655 9.81388 10.0063 9.58416Z" fill="currentColor" />
      </g>
    </g>
  </svg>
)

MutedIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

MutedIcon.defaultProps = {
  width: 41,
  height: 40,
  title: 'Menu',
}

export default MutedIcon
